// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-477e5334] .el-dialog__body {\n  padding: 10px 10px;\n  height: 270px;\n  overflow: auto;\n}\n.el-form-item--mini.el-form-item[data-v-477e5334] {\n  margin-bottom: 10px;\n}", ""]);
// Exports
module.exports = exports;
